document.addEventListener('DOMContentLoaded', function() {
  const filterBtns = document.querySelectorAll('.filter-btn');
  const blogContainer = document.getElementById('blog-articles-container');
  const loadingOverlay = document.querySelector('.loading-overlay');
  
  // Store current URL for history management
  let currentUrl = window.location.href;

  function showLoading() {
    loadingOverlay.classList.add('show');
  }

  function hideLoading() {
    loadingOverlay.classList.remove('show');
  }

  function updateContent(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const newContent = doc.querySelector('#blog-articles-container');
    
    if (newContent) {
      blogContainer.innerHTML = newContent.innerHTML;
      
      // Reinitialize pagination click handlers
      initializePaginationHandlers();
      
      // Trigger animations if enabled
      if (window.theme && window.theme.initializeScrollAnimationTrigger) {
        window.theme.initializeScrollAnimationTrigger();
      }
    }
  }

  function initializePaginationHandlers() {
    const paginationLinks = document.querySelectorAll('#pagination-container a');
    paginationLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        const url = this.href;
        loadPage(url);
      });
    });
  }

  async function loadPage(url) {
    try {
      showLoading();
      
      const response = await fetch(url, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
      
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      
      const html = await response.text();
      updateContent(html);
      
      // Update browser history
      if (url !== currentUrl) {
        window.history.pushState({}, '', url);
        currentUrl = url;
      }
      
    } catch (error) {
      console.error('Error loading page:', error);
      // Handle error - maybe show a message to user
    } finally {
      hideLoading();
    }
  }

  // Filter button click handlers
  filterBtns.forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      
      const url = this.dataset.url;
      
      // Update active button
      filterBtns.forEach(b => b.classList.remove('active'));
      this.classList.add('active');
      
      // Load filtered content
      loadPage(url);
    });
  });

  // Initialize pagination handlers on page load
  initializePaginationHandlers();

  // Handle browser back/forward buttons
  window.addEventListener('popstate', function() {
    location.reload(); // Simple solution - reload page on back/forward
  });
});